// Hooks
import { useIsProfileUnderReview } from 'hooks';
// Ui3
import Banner from 'ui3/Banner/Banner';
// Styles
import styles from './ProfileUnderRevireBanner.module.scss';

const ProfileUnderReviewBanner = () => {
  const isPendingApproval = useIsProfileUnderReview();

  return (
    <Banner
      open={isPendingApproval}
      type="default"
      message="Your profile is currently under review. Completing your profile will speed up the process."
      className={styles.banner}
    />
  );
};

export default ProfileUnderReviewBanner;
